export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * MINUTES_PER_HOUR;
export const SECOND = 1000;
export const MINUTE = SECOND * SECONDS_PER_MINUTE;
export const HOUR = MINUTE * MINUTES_PER_HOUR;
